import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

export default function Unsubscribed() {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type'); // 'jobs' for job-alert unsubscribe, null for general

  const isJobsOnly = type === 'jobs';

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#F9FAFB',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'Arial, Helvetica, sans-serif',
      padding: '24px',
    }}>
      <div style={{
        backgroundColor: '#FFFFFF',
        borderRadius: '8px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
        maxWidth: '480px',
        width: '100%',
        padding: '48px 40px',
        textAlign: 'center',
      }}>
        {/* Icon */}
        <div style={{
          width: '56px',
          height: '56px',
          borderRadius: '50%',
          backgroundColor: '#FFF7ED',
          border: '2px solid #FED7AA',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px auto',
          fontSize: '24px',
        }}>
          ✉️
        </div>

        {/* Heading */}
        <h1 style={{
          margin: '0 0 12px 0',
          fontSize: '22px',
          fontWeight: 'bold',
          color: '#111827',
        }}>
          {isJobsOnly ? 'Unsubscribed from job alerts' : "You've been unsubscribed"}
        </h1>

        {/* Sub-text */}
        <p style={{
          margin: '0 0 8px 0',
          fontSize: '15px',
          color: '#6B7280',
          lineHeight: '1.6',
        }}>
          {isJobsOnly
            ? <>You won't receive job alert emails from{' '}<span style={{ color: '#EA580C', fontWeight: 'bold' }}>GRRAS Learning Labs</span> anymore.</>
            : <>You won't receive any more emails from{' '}<span style={{ color: '#EA580C', fontWeight: 'bold' }}>GRRAS Learning Labs</span>.</>
          }
        </p>

        <p style={{
          margin: '0 0 32px 0',
          fontSize: '14px',
          color: '#9CA3AF',
          lineHeight: '1.6',
        }}>
          {isJobsOnly
            ? <>Changed your mind? Re-enable job alerts from your{' '}<a href="/profile" style={{ color: '#EA580C', textDecoration: 'underline' }}>Profile → Job Settings</a>.</>
            : <>Changed your mind?{' '}<a href="mailto:support@grras.tech" style={{ color: '#EA580C', textDecoration: 'underline' }}>Contact us at support@grras.tech</a></>
          }
        </p>

        {/* Back to dashboard */}
        <Link
          to="/dashboard"
          style={{
            display: 'inline-block',
            backgroundColor: '#EA580C',
            color: '#FFFFFF',
            padding: '12px 28px',
            borderRadius: '6px',
            textDecoration: 'none',
            fontSize: '14px',
            fontWeight: 'bold',
            letterSpacing: '0.3px',
          }}
        >
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
}
